import { compose } from 'ramda'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import moment from 'moment'

import Button from '../../actions/Button'
import DayPicker from './DayPicker'
import FlexGrid from '../../structure/FlexGrid'
import InputButton from '../InputButton'
import Modal from '../../structure/Modal'
import Separator from '../../helpers/Separator'
import TimeInput from '../TimeInput'

const DateInput = ({ disabled, onChange, value, useRange, useTime, ...props }) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  const onClose = () => setOpen(false)
  const onOpen = () => setOpen(true)

  const [time, setTime] = useState(value)
  const [day, setDay] = useState(value)
  const onConfirmDateTime = () => {
    if (!day) {
      onChange(undefined)
    } else {
      onChange(moment(day).hour(moment(time).hour()).minute(moment(time).minute()).toDate())
    }
    onClose()
  }
  const changeAndClose = compose(onClose, onChange)
  const handleChangeDay = useTime ? setDay : changeAndClose
  const handleChangeTime = setTime

  let formattedValue = undefined
  let formatStr = 'DD/MM/YYYY'
  if (useTime) {
    formatStr += ' HH:mm'
  }

  if (useRange) {
    const [from, to] = value || []
    formattedValue = from && to && moment(from).format(formatStr) + ' - ' + moment(to).format(formatStr)
  } else {
    formattedValue = value && moment(value).format(formatStr)
  }

  return (
    <div>
      <InputButton disabled={disabled} onClick={onOpen} value={formattedValue} iconRight="BsCalendar" />
      <Modal open={open} onClose={onClose} width="22rem" minHeight="28rem">
        <DayPicker value={day} onChange={handleChangeDay} useRange={useRange} {...props} />

        {useTime && (
          <div>
            <Separator weight={4} />
            <TimeInput value={time} onChange={handleChangeTime} disabled={!day} />
            <Separator weight={6} />
            <FlexGrid justify="flex-end">
              <Button onClick={onConfirmDateTime}>{t('confirm')}</Button>
            </FlexGrid>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default DateInput
